import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";
import config from "appConfig";

const items = [
  {
    id: "6fb5707a-3e4e-421c-9f2a-d8b086d38fd3",
    options: { imageUrl: `${config.ASSETS_URL}/03/20/task/task-1-item-1.png` },
  },
  {
    id: "f943a192-bd9a-4690-b7b9-fd075d9fc596",
    options: { imageUrl: `${config.ASSETS_URL}/03/20/task/task-1-item-2.png` },
  },
];

const groups = [
  { id: "e6f9ecc3-6cb3-4b23-9913-141be13f151c", content: "Open-Back", options: {} },
  { id: "fe92701d-5050-451b-a611-d478923015ff", content: "Closed-Back", options: {} },
];

export const task: Task = {
  id: "a5edc9b8-5889-48f0-ae58-010a56215049",
  solutionType: "group",
  type: "connectWithLine",
  options: {
    shuffle: true,
  },
  items,
  groups,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "group",
  data: [
    { groupId: "e6f9ecc3-6cb3-4b23-9913-141be13f151c", itemsId: ["f943a192-bd9a-4690-b7b9-fd075d9fc596"] },
    { groupId: "fe92701d-5050-451b-a611-d478923015ff", itemsId: ["6fb5707a-3e4e-421c-9f2a-d8b086d38fd3"] },
  ],
};
